import React, { useEffect, useRef } from "react";
import { Hooks } from "@xt/xtbase";
import styles from "./addFavTooltip.module.less";

const { useTranslation } = Hooks;

/**
 * Fiat-M / USDT-M 长按数据时弹出的 "Add to Favorites" 气泡。
 * 尺寸参考 Figma 12392:65747：110 x 37，#36373E 背景，白色 12px 文本。
 */
const AddFavTooltip = ({ position, alreadyFav, onClose, onConfirm }) => {
  const ref = useRef(null);
  const t = useTranslation();

  useEffect(() => {
    const handleDocInteract = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) onClose && onClose();
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose && onClose();
    };
    document.addEventListener("mousedown", handleDocInteract);
    document.addEventListener("touchstart", handleDocInteract);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleDocInteract);
      document.removeEventListener("touchstart", handleDocInteract);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const style = position ? { left: `${position.x}px`, top: `${position.y}px` } : {};

  return (
    <button
      ref={ref}
      type="button"
      className={styles.tooltip}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        // 无论当前是否已收藏都回调到 caller，由 caller 根据 alreadyFav 自行决定 add / remove
        onConfirm && onConfirm(alreadyFav);
        onClose && onClose();
      }}
    >
      {alreadyFav ? t("market.favRemove") : t("market.addToFavorites")}
    </button>
  );
};

export default AddFavTooltip;
